import { Component } from '@angular/core';
import { Meetings } from './meetings';
declare var createGoogleEvent: any;

@Component({
  selector: 'app-meeting-schedule',
  templateUrl: './meeting-schedule.component.html',
  styleUrls: ['./meeting-schedule.component.sass']
})
export class MeetingScheduleComponent {

  meetings: any[] = Meetings;
  date: Date = new Date();

  ngOnInit(): void {
    this.compareDate()
  }

  compareDate() {
    let isFirst = false;
    this.meetings = Meetings.map((meeting) => {
      const item = { ...meeting };
      const meetingDate = new Date(item.fullDate);

      item.active = this.date.getTime() <= meetingDate.getTime();
      if (!isFirst && item.active) {
        item.currentMonth = true;
        isFirst = true;
      } else {
        item.currentMonth = false;
      }

      return item;
    });
  }

  scheduleMeeting(index: number) {
    let meet = this.meetings[index]['fullDate'] as Date
    let meetingHour = this.meetings[index]['meetingHour'] as number
    let month = meet.getMonth();
    let day = meet.getDate();
    let year = meet.getFullYear();

    const markedTime = new Date(year, month, day, meetingHour)
    markedTime.setHours(markedTime.getHours() - 3)

    const startTime = markedTime.toISOString().slice(0, 18) + '-03:00'
    const endTime = this.getEndTime(markedTime);

    const eventDetails = {
      'summary': 'Reunião do COMDICA',
      'location': 'Rua Dr. Carlos Mateus, nº1454, centro, Parnamirim/RN – 59.146-210',
      'description': 'Reunião do Conselho Municipal dos Direitos da Criança e do Adolescente',
      'startTime':startTime,
      'endTime': endTime
    }
    createGoogleEvent(eventDetails);
  }

  getEndTime(markedTime: Date): string {
    markedTime.setHours(markedTime.getHours() + 1)
    const endTime = markedTime.toISOString().slice(0,18) + '-03:00'
    return endTime;
  }

}
